import Swiper from 'swiper/bundle'; // Import Swiper functionality
// import 'swiper/swiper-bundle.min.css'; // Import Swiper styles

document.addEventListener('DOMContentLoaded', function() {
    // Find all Swiper containers and initialize Swiper for each.
    const swipers = document.querySelectorAll('.hero-slider .swiper-container');
    
    swipers.forEach((swiperContainer) => {
        new Swiper(swiperContainer, {
            // Swiper options
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
});
